

export class Employee_Dashboard_Daily_InOut_Dto implements IEmployee_Dashboard_Daily_InOut_Dto {
    thumbIn!: Date | undefined;
    thumbOut!: Date | undefined;
    presentTime!: Date | undefined;

    constructor(data?: IEmployee_Dashboard_Daily_InOut_Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.thumbIn = _data["thumbIn"] ? new Date(_data["thumbIn"].toString()) : <any>undefined;
            this.thumbOut = _data["thumbOut"] ? new Date(_data["thumbOut"].toString()) : <any>undefined;
            this.presentTime = _data["presentTime"] ? new Date(_data["presentTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Employee_Dashboard_Daily_InOut_Dto {
        data = typeof data === 'object' ? data : {};
        let result = new Employee_Dashboard_Daily_InOut_Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thumbIn"] = this.thumbIn ? this.thumbIn.toISOString() : <any>undefined;
        data["thumbOut"] = this.thumbOut ? this.thumbOut.toISOString() : <any>undefined;
        data["presentTime"] = this.presentTime ? this.presentTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IEmployee_Dashboard_Daily_InOut_Dto {
    thumbIn: Date | undefined;
    thumbOut: Date | undefined;
    presentTime: Date | undefined;
}

